import { render } from "./S950_FehlerhafteRechnungen.vue?vue&type=template&id=0b0b8521&scoped=true&ts=true"
import script from "./S950_FehlerhafteRechnungen.vue?vue&type=script&lang=ts"
export * from "./S950_FehlerhafteRechnungen.vue?vue&type=script&lang=ts"

import "./S950_FehlerhafteRechnungen.vue?vue&type=style&index=0&id=0b0b8521&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0b8521"]])

export default __exports__